import { Component, OnInit, Input } from '@angular/core';
import { LabTestPopupComponent } from './lab-test-popup.component';
import { DialogService } from '../../../shared/services/dialog.service';
import { ConsultationHistoryService } from '../consultation-history.service';
import { LabTestDataService } from '../../master-data/lab-test-data/lab-test-data.service';
import { AppConstants } from '../../../shared/constants/constants';
import { AppMessages } from '../../../shared/constants/messages';

@Component({
  selector: 'ch-lab-test',
  templateUrl: 'lab-test.component.html',
  providers: [ConsultationHistoryService, LabTestDataService],
  styleUrls: ['lab-test.componenet.scss']
})

export class LabTestComponent implements OnInit {
  @Input() history: boolean;
  @Input() patientId: string;
  @Input() labTest: any[];
  @Input() consultationHistoryId: string;
  @Input() height: number;
  public histories = [];
  public orderedLabtest: any[];
  public klass = 'consultationhistory';

  public appConstants = AppConstants;

  public labtestTestResultData = [];

  constructor(public dialog: DialogService, public consultationHistoryService: ConsultationHistoryService, private labTestService: LabTestDataService) { }

  ngOnInit() {
    this.height = this.height ? (this.height > 600 ? this.height - 172 : this.height - 185) : null;

    this.labTestService.getLabtestTestResult().subscribe(
      result => {
        if (result) {
          const data = result.json();
          this.labtestTestResultData = data['list'];
        }
      }
    );

  }

  confirmLabtestResult(item: any) {
    if (item.testResult && item.testResult !== 0) {
      var testResultName = '';
      var result = this.labtestTestResultData.find(d => d.id == item.testResult);
      if (result) {
        testResultName = result.name;
      }

      var message = '<div class="confirm-labtest-line-1">You are recording results for the following test:</div> <div class="confirm-labtest-line-2"> <p>Test name: <b>' + item.labTestName + '</b></p> <p class="confirm-labtest-break">-</p> <p>Result:  <b>' + testResultName + '</b></p> </div>';
      this.dialog.openConfirmationDialog({ message: message }).subscribe(
        (result) => {
          if (result) {
            // call API to save data
            this.consultationHistoryService
              .savePatientLabtestTestResult(this.consultationHistoryId, item)
              .subscribe(
                (result) => {
                  const resData = result.json();

                  item.isSavedTestResult = true;
                  this.dialog.openSuccessDialog({ message: resData.message });
                }
              );
          }
        }
      );
    }
    else {
      this.dialog.openErrorDialog({ message: AppMessages.labTest.provideTestResult });
    }
  }


  openLabTest() {
    const height = window.screen.height - (window.screen.height * 30 / 100);
    const data = {
      patientId: this.patientId,
      consultationHistoryId: this.consultationHistoryId,
      height: height
    };
    this.dialog.openComponentDialog(LabTestPopupComponent, data, { width: '80%', height: height + 'px' }).subscribe(result => {
      if (result) {
        this.consultationHistoryService.getLabTest(data.consultationHistoryId).subscribe(callback => {
          if (callback) {
            this.labTest = callback.json();
          }
        });
      }
    });
  }
}



// WEBPACK FOOTER //
// D:/TMB/sr-git-v1/TMB.UI/src/app/pages/consultation-history/lab-test/lab-test.component.ts